import {UserCellProps} from './types';
import {StyledUserCell} from './styles';

import {Avatar} from '@molecules';
import {P, Subtitle} from '@quarks';

export const UserCell = ({
  className,
  left,
  right,
  shouldShowCheckIn,
  style,
  subtitle,
  user,
  padding,
  separator,
  ...props
}: UserCellProps) => {
  return (
    <StyledUserCell
      padding={padding}
      separator={separator}
      className={className}
      left={
        left || (
          <Avatar
            shouldShowCheckIn={shouldShowCheckIn}
            user={user}
          />
        )
      }
      middle={
        <>
          <P className="font-semibold truncate">{user.displayName || user.name || user.email}</P>

          {typeof subtitle === 'string' ? <Subtitle className="truncate">{subtitle}</Subtitle> : subtitle}
        </>
      }
      right={right}
      style={style}
      {...props}
    />
  );
};
